var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"elementary-section",class:{'elementary-section--has-shadow': _vm.shadow, 'bg--light': _vm.light}},[_c('div',{staticClass:"elementary-section__in"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }